export const HEADER = 'header';
export const LAST_CHANCE = 'lastChance';
export const PICKS_FOR_YOU = 'picksForYou';
export const POPULAR_CATEGORIES = 'popularCategories';
export const RECENTLY_VIEWED = 'recentlyViewed';
export const INSTAGRAM_FEED = 'instagramPosts';
export const WISH_LIST = 'wishList';
export const FAVOURITE_SELLERS = 'favouriteSellers';
export const CATEGORY_LINKS = 'categoryLinks';
export const SAVED_SEARCHES = 'savedSearches';
export const LAST_SEARCH = 'lastSearch';
export const DISCOVER_SUGGESTIONS = 'discoverSuggestions';
export const FAVOURITE_SELLERS_ITEMS = 'favouriteSellerItems';
export const NEAR_YOU = 'nearYou';
